import { render, staticRenderFns } from "./ProductVariant.vue?vue&type=template&id=3013fd2a&scoped=true"
import script from "./ProductVariant.vue?vue&type=script&lang=js"
export * from "./ProductVariant.vue?vue&type=script&lang=js"
import style0 from "./ProductVariant.vue?vue&type=style&index=0&id=3013fd2a&prod&lang=scss"
import style1 from "./ProductVariant.vue?vue&type=style&index=1&id=3013fd2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3013fd2a",
  null
  
)

export default component.exports